import { DialogService } from "@/service/DialogService";
import { computed, ref } from "vue";

export function useTab(defaultTab: string) {
  const tab = ref(defaultTab)
  const currentTab = computed(() => {
    return `parts-${tab.value}`
  })


  const changeTab = async (tabName: string, showDialog: boolean = false, dialogMessage = 'タブを切り替えると編集中の内容は破棄されます。<br>切り替えますか？') => {
    const res = await DialogService.warning({
      html: dialogMessage,
      confirmButtonText: 'はい',
      showCancelButton: true,
      cancelButtonText: 'いいえ',
    })

    if (!res.isConfirmed) return

    tab.value = tabName
  }

  return {
    tab,
    currentTab,
    changeTab
  }
}
